@if ({
  data: (data$ | async)
  }; as _) {
  @if (_.data) {
    <div id="dialog-page" data-test="error-dialog">
      <div id="dialog" class="py-10 px-8 mx-10 accent-background relative flex flex-col space-y-8 max-w-[600px]">
        @if (_.data.icon) {
          <cds-svg-icon [autofill]="false" class="w-9 self-center" [name]="_.data.icon"></cds-svg-icon>
        }
        @if (_.data.title) {
          <p class="text-center" [innerHTML]="_.data.title | translate"></p>
        }
        @if (_.data.button && _.data.actionCallback) {
          <button cdsButton appRipple id="error-dialog-btn" data-test="error-dialog-btn" color="primary" class="w-full popup" (debounceClick)="_.data.actionCallback()" [innerHTML]="_.data.button | translate"></button>
        }
      </div>
    </div>
  }
}

